import { getHotelsProfileImages } from "../services/fhpService";
import {
  coerceGenericImagesToUrlList,
  parseHotelImagesResponseBody,
} from "./hotelProfileGalleryUrls";

/**
 * Full hotel gallery from /hotelImages — same source as HotelProfile.
 * @param {string|number|null|undefined} hotelId
 * @returns {Promise<string[]>}
 */
export async function fetchHotelOfferGalleryUrlsByHotelId(hotelId) {
  const n = parseInt(String(hotelId ?? "").trim(), 10);
  if (!Number.isFinite(n) || n <= 0) return [];
  try {
    const res = await getHotelsProfileImages({ hotelID: n });
    const body = parseHotelImagesResponseBody(res?.data);
    const gi = body.GenericImages ?? body.genericImages;
    const raw =
      gi && typeof gi === "object" ? gi.images ?? gi.Images : null;
    return coerceGenericImagesToUrlList(raw).slice(0, 24);
  } catch {
    return [];
  }
}

/** @param {object|null|undefined} payload */
export function resolveHotelOfferGalleryHotelId(payload) {
  const root = payload && typeof payload === "object" ? payload : {};
  const selection =
    root.selection && typeof root.selection === "object" ? root.selection : {};
  const searchPhrase =
    selection.search_phrase && typeof selection.search_phrase === "object"
      ? selection.search_phrase
      : {};
  const candidates = [
    root.hotel_id,
    root.hotelId,
    root.hotelID,
    searchPhrase.hotelID,
    searchPhrase.hotelId,
    searchPhrase.HotelId,
  ];
  for (const value of candidates) {
    const n = parseInt(String(value ?? "").trim(), 10);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}
